/** Thrown when config value is not found in config manager. */
export class ConfigManagerValueAlreadyExistsException extends Error {
  constructor(name: string, managerName: string) {
    super(`Config value '${name}' already exists ${managerName}.`);
  }
}
